
  <mat-select [formControl]="formControl" [formlyAttributes]="field">
  <mat-option *ngIf="!to.defaultOptions"> --- </mat-option>
  <div *ngIf="to.defaultOptions">
    <div *ngFor="let option of to.defaultOptions">
      <mat-option [value]="option.value"> {{ option.label }} </mat-option>
    </div>
  </div>
  <div *ngFor="let item of items">
    <mat-option *ngFor="let subItem of item.values" [value]="subItem._id">
      {{ subItem.nome }}
    </mat-option>
  </div>
</mat-select>
  